import { Field, Input, Label, Select } from '../Field';

const units = [
    { id: 'minutes', name: 'Minutos' },
    { id: 'hours', name: 'Horas' },
    { id: 'days', name: 'Dias' },
    { id: 'weeks', name: 'Semanas' },
    { id: 'months', name: 'Meses' },
];

function AppointmentsTab({ clinic, t }) {
    return (
        <div className="space-y-2">
            <Field>
                <Label>
                    <span>{t('booking-gap')}</span>
                    <div className="flex max-w-xs gap-2">
                        <Input type="number" min="0" defaultValue={clinic?.booking_gap} name="booking_gap" />
                        <Select name="booking_gap_unit" placeholder="Unidade" defaultValue={clinic?.booking_gap_unit} options={units} noEmpty={true} />
                    </div>
                </Label>
            </Field>

            <Field>
                <Label>
                    <span>{t('canceling-gap')}</span>
                    <div className="flex max-w-xs gap-2">
                        <Input type="number" min="0" defaultValue={clinic?.canceling_gap} name="canceling_gap" />
                        <Select name="canceling_gap_unit" placeholder="Unidade" defaultValue={clinic?.canceling_gap_unit} options={units} noEmpty={true} />
                    </div>
                </Label>
            </Field>

            <Field>
                <Label>
                    <div className="max-w-lg">
                        <span>Desconto (Português)</span>
                        <Input type="text" name="discount[pt]" defaultValue={clinic?.discount} />
                    </div>
                </Label>
            </Field>

            <Field>
                <Label>
                    <div className="max-w-lg">
                        <span>Desconto (English)</span>
                        <Input type="text" name="discount[en]" defaultValue={clinic?.discount_en} />
                    </div>
                </Label>
            </Field>

            <Field>
                <Label>
                    <div className="max-w-lg">
                        <span>Desconto (Français)</span>
                        <Input type="text" name="discount[fr]" defaultValue={clinic?.discount_fr} />
                    </div>
                </Label>
            </Field>

            {/* <Field>
                <Label>
                    <div className="max-w-lg">
                        <span>Valor dos Cupões (&euro;)</span>
                        <Input type="number" min="0" step="0.01" name="coupon" defaultValue={clinic?.coupon} />
                    </div>
                </Label>
            </Field> */}
        </div>
    );
}

export default AppointmentsTab;
